import { useLayoutEffect } from "react";
import { LegacyFrame } from "./LegacyFrame";
import { NotFound } from "@/pages/NotFound";
import { useLayout } from "@/contexts/LayoutContext";
import { LEGACY_FRAME_STATE_KEY, hasShellBypass, isLegacyShellPath, isPopupWindow, replaceLocation, withShellBypass } from "@/utils/legacyShell";
import { useLocation } from "react-router";

const currentUrl = () => window.location.pathname + window.location.search + window.location.hash;

export const LegacyOrNotFound = () => {
  const { data } = useLayout();
  const { pathname, state } = useLocation();
  const frameDriven = (state as Record<string, unknown> | null)?.[LEGACY_FRAME_STATE_KEY] === true;
  const isLegacy = frameDriven || isLegacyShellPath(pathname, data.legacyShell);
  const breakOut = isLegacy && isPopupWindow(window) && !hasShellBypass(currentUrl());

  useLayoutEffect(() => {
    if (breakOut) replaceLocation(withShellBypass(currentUrl()));
  }, [breakOut]);

  if (breakOut) return null;
  return isLegacy ? <LegacyFrame /> : <NotFound />;
};
